import { Component, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-create-form-date-range-recurring-n-days',
  templateUrl: './create-form-date-range-recurring-n-days.component.html',
  styleUrls: ['./create-form-date-range-recurring-n-days.component.scss']
})
export class CreateFormDateRangeRecurringNDaysComponent implements OnInit, ControlValueAccessor {

  constructor(
    public ngControl: NgControl
  
  ) { 
    ngControl.valueAccessor = this;
  }

  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}



  ngOnInit(): void {


  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  onInputChange(value: any){
    this.modelChange(value)
  }


  modelChange(value: string){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }


}
